<div class="loader" *ngIf="isReportSummaryLoading">
    <app-three-dots-blinking></app-three-dots-blinking>
</div>
<div class="container" *ngIf="!isReportSummaryLoading">
    <div class="header">

        <button #dropdownButton class="account-switch-button" *ngIf="isAccountSwitcherVisible"
            (click)="$event.stopPropagation(); toggleDropdown()">
            {{selectedAccountInfo?.customerName + " | " + selectedAccountInfo?.name}}
            <img src="assets/icons/arrow/chevron-down.svg" alt="{{ 'reporting.DOWN_ARROW' | transloco }}"
                class="account-switch-icon">
        </button>

        <h1>{{'reporting.AT_GLANCE' | transloco}}</h1>
        <div class="statistics">
            <div class="statistic-wrapper">
                <div class="statistic__value">{{reportingSummary?.moduleAssignmentCount}}</div>
                <div class="statistic__label">{{'reporting.OPEN_ASSIGNMENTS' | transloco}}</div>
            </div>
            <div class="statistic-wrapper">
                <div class="statistic__value">{{reportingSummary?.notStarted?.percentage}} %</div>
                <div class="statistic__label">{{'reporting.NOT_STARTED' | transloco}}</div>
            </div>
            <div class="statistic-wrapper"
                *ngIf="reportingSummary && reportingSummary.certificationModuleAssignmentCount > 0">
                <div class="statistic__value">{{reportingSummary.completed.percentage}} %</div>
                <div class="statistic__label">{{'reporting.CERTIFIED' | transloco}}</div>
            </div>

        </div>
    </div>
    <div class="notification" *ngIf="showAlertBox">
        <div class="notification__icon">
            <img src="assets/icons/alert-circle-lg.svg" alt="{{ 'reporting.NOTIFICATION' | transloco }}">
        </div>
        <div class="notification__content">
            <div class="notification__title">{{alertTitle}}</div>
            <div class="notification__message">{{alertMessage}}</div>
            <div class="cta" (click)="openModal()">{{'reporting.VIEW_LIST' | transloco}}</div>
        </div>

    </div>
</div>
<div class="loader" *ngIf="isReportLoading && !isReportSummaryLoading">
    <app-three-dots-blinking></app-three-dots-blinking>
</div>
<app-modules-list [accountUuid]="selectedAccountInfo!.uuid" *ngIf="!isReportLoading">
</app-modules-list>
<app-certification-assignments [liveData]="liveData" [oldData]="oldData"
    [headerText]="'reporting.CERTIFICATION_ASSIGNMENTS' | transloco"
    [summaryText]="'reporting.CERTIFICATION_SUMMARY_TEXT' | transloco"
    [moduleAssignmentCount]="reportingSummary.certificationModuleAssignmentCount"
    (loadCertificationAssignments)="handleLoadCertificationAssignments()"
    *ngIf="!isReportLoading && reportingSummary && reportingSummary.certificationModuleAssignmentCount > 0">
</app-certification-assignments>
<div class="loader" *ngIf="!isReportLoading && !isReportSummaryLoading && isPracticeAssignmentLoading">
    <app-three-dots-blinking></app-three-dots-blinking>
</div>
<app-practice-assignments [practiceLiveData]="practiceLiveData" [practiceOldData]="practiceOldData"
    [headerText]="'reporting.PRACTICE_ASSIGNMENTS' | transloco"
    [summaryText]="'reporting.PRACTICE_SUMMARY_TEXT' | transloco"
    [moduleAssignmentCount]="reportingSummary.practiceModuleAssignmentCount"
    (loadPracticeAssignments)="handleLoadPracticeAssignments()"
    *ngIf="!isPracticeAssignmentLoading && reportingSummary && reportingSummary.practiceModuleAssignmentCount > 0">
</app-practice-assignments>